import React from 'react';
import PropTypes from 'prop-types';
import { TextArea } from 'uikit/inputs';

const FormFieldTextArea = ({
  fieldId,
  value = '',
  updateField,
  schema = {
    value: '',
    schema: {
      className: '',
      placeholder: '',
      isDisabled: false,
      maxLength: null,
    },
  },
}) => (
  <TextArea
    id={fieldId}
    placeholder={schema.placeholder}
    value={value === null ? '' : value}
    onChange={updateField}
    isDisabled={schema.isDisabled}
    maxLength={schema.maxLength}
  />
);

FormFieldTextArea.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.string,
  updateField: PropTypes.func.isRequired,
  schema: PropTypes.shape({
    placeholder: PropTypes.string,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.number,
  }),
};

export default FormFieldTextArea;
